import { render, staticRenderFns } from "./fenxiao.vue?vue&type=template&id=521d1747&scoped=true&"
import script from "./fenxiao.vue?vue&type=script&lang=js&"
export * from "./fenxiao.vue?vue&type=script&lang=js&"
import style0 from "./fenxiao.vue?vue&type=style&index=0&id=521d1747&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521d1747",
  null
  
)

export default component.exports